module.exports = __webpack_public_path__ + "static/img/mini_programm.916af05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mini_programm.png
// module id = 7jkk
// module chunks = 23 29